import { BrowserRouter, Route, Routes } from "react-router-dom";
// * components
import HomeLayout from "./layouts/home";
import LogIn from "./pages/LogIn";
import HomeScreen from "./pages/Home";
import NotificationScreen from "./pages/Notification";
import RewardScreen from "./pages/Reward";

const Root = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LogIn />} />
        <Route path="/admin" element={<HomeLayout />}>
          <Route index element={<HomeScreen />} />
          <Route path="/admin/notification" element={<NotificationScreen />} />
          <Route path="/admin/reward" element={<RewardScreen />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Root;
